import "./Table.css";

import Module from "../Module/Module";
import { linkifyText } from "../utils";
import { useMemo } from "react";

function Td(col) {
  if (!col) return;
  const centerText = ["period", "grade", "subject"].includes(
    col.colName.toLowerCase()
  );
  if (!col.text && !col.file && col.resources && !col.resources.length)
    return (
      <td style={{ textAlign: centerText ? "center !important" : "left" }}>
        N/A
      </td>
    );

  if (col.resources && col.resources.length) {
    return (
      <td
        className="module"
        style={{ textAlign: centerText ? "center" : "left" }}
      >
        {col.resources.map((resource, ind) => (
          <Module
            style={{ backgroundColor: "#ffffff" }}
            resource={resource}
            key={ind}
          />
        ))}
      </td>
    );
  } else if (col.colType === "link") {
    return col.file ? (
      <td>
        <a target="_blank" rel="noreferrer" href={col.file?.fileLink}>
          {col.file?.fileName}
        </a>
      </td>
    ) : (
      <td dangerouslySetInnerHTML={{ __html: linkifyText(col.text) }}></td>
    );
  } else {
    return (
      <td
        style={{ textAlign: centerText ? "center" : "left" }}
        dangerouslySetInnerHTML={{ __html: linkifyText(col.text) }}
      ></td>
    );
  }
}

export default function Table(props) {
  const tableData = useMemo(() => {
    return props.columns.reduce(
      (data, col) => {
        data.col.push({ colName: col.colName, colIndex: col.colIndex });
        data.rows.push(col.cells);
        return data;
      },
      { col: [], rows: [] }
    );
  }, [props.columns]);

  return props.view ? (
    <table
      ref={props.sectionRef}
      style={props.style}
      className={`preview-table ${props.className}`}
    >
      <thead>
        <tr>
          {(tableData?.col || []).map((col) => {
            return (
              <th className="head" key={col.colName}>
                {col.colName}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {props.columns.map((_, rowIndex) => {
          return (
            <tr key={_.colName} className="pagebreak">
              {(tableData.col || []).map((_, colIndex) => {
                const row = (tableData.rows || [])[colIndex] || [];
                const cell = row[rowIndex];
                return Td(cell, colIndex);
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <table
      ref={props.sectionRef}
      style={props.style}
      className={`preview-table ${props.className}`}
    >
      <tbody>
        {(tableData.col || []).map((col, colIndex) => (
          <tr key={colIndex} className="pagebreak">
            <td className="head">{col.colName}</td>
            {props.columns.map((_, rowIndex) => {
              const row = (tableData.rows || [])[colIndex] || [];
              const cell = row[rowIndex];
              return Td(cell, rowIndex);
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
